module.exports = __webpack_public_path__ + "img/ur3_feature_02.1e9d6b86.jpg";